import { render } from "./Prompt.vue?vue&type=template&id=304df06e"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__